/**
* Before After Gallery JS
* -----------------------------------------------------------------------------
*
* All the JS for the Before After Gallery component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      if ( $( '.bag_archive-banner' ).length ) {
        console.log( 'before-after-gallery' );
        $( '.bag_archive-banner' ).addClass( 'theme-four' );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'bag', COMPONENT );
} )( app );
